import axios from 'axios'

export default() => {
    return axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        withCredentials: false,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': process.env.VUE_APP_URL,
            'Authorization': 'Bearer ' + localStorage.getItem('access_token')
        }
    })
}